export const getBaseUrl = () => {
  if (!window?.location) {
    return '';
  }

  return window.location.protocol + '//' + window.location.host;
};
